import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

function SnapshotCard({ title, description, type, image, onClick, isSelected }) {

  const theme = useTheme();
  const { palette, functions } = theme;
  const { grey, white } = palette;

  return (
    <Card
      onClick={onClick}
      sx={{
        height: "100%",
        maxWidth: 275,
        display: "flex",
        borderRadius: 2,
        flexDirection: "column",
        justifyContent: "space-between",
        cursor: "pointer",
        boxShadow: isSelected ? 6 : 1,
        border: isSelected ? "2px solid #00A1A1" : "1px solid #ddd",
        transition: "all 0.3s ease-in-out",
        "&:hover": {
          transform: "translateY(-6px)",
          boxShadow: 6,
        },
        backgroundColor: isSelected ? "grey.500" : "grey.100",
      }}
    >
      <CardMedia
        component="img"
        height="200px"
        image={image}
        alt={`${title} image`}
        sx={{ objectFit: "fill" }}
      />
      <CardContent>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </CardContent>
      {isSelected && (
        <MDBox
          sx={{
            position: "absolute",
            bottom: 8,
            right: 8,
            backgroundColor: "#26282b",
            borderRadius: "50%",
            width: 20,
            height: 20,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CheckCircleIcon color="accent" sx={{ fontSize: 18 }} />
        </MDBox>
      )}
    </Card>
  );
}

export default SnapshotCard;
